import { router } from '@inertiajs/vue3';
import { computed, onBeforeUnmount, onMounted, Ref, ref } from 'vue';

type OnlyParam = string[] | (() => string[]);

interface UseReloadOnFocusOptions {
    only: OnlyParam;
    enabled?: Ref<boolean> | boolean;
}

export default function useReloadOnFocus({ only, enabled = true }: UseReloadOnFocusOptions) {
    const isReloading = ref(false);

    const isEnabled = computed(() => (typeof enabled === 'boolean' ? enabled : !!enabled?.value));
    const onlyList = computed<string[]>(() => (typeof only === 'function' ? (only as () => string[])() : (only as string[])));

    const reloadOnFocus = () => {
        if (!isEnabled.value) return;
        if (isReloading.value) return;

        isReloading.value = true;

        router.reload({
            only: onlyList.value,
            onFinish: () => {
                isReloading.value = false;
            },
        });
    };

    onMounted(() => {
        window.addEventListener('focus', reloadOnFocus);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('focus', reloadOnFocus);
    });

    return { isReloading, reloadOnFocus };
}
